import axios from "axios";

let url = "";
let stag_url = "";
let Is_Retailer = "";
let APP_LANGUAGE= "";
let OtherSiteLink= "";
url = import.meta.env.VITE_APP_API || "";
stag_url = import.meta.env.VITE_APP_ASSETS_URL || "";
Is_Retailer = import.meta.env.VITE_IS_RETAILER || "";
APP_LANGUAGE = import.meta.env.VITE_APP_LANGUAGE || "";
OtherSiteLink = import.meta.env.VITE_APP_OTHER_SITE_URL || "";

export { Is_Retailer ,APP_LANGUAGE ,OtherSiteLink};
export const path = () => {
  return stag_url;
};
export default axios.create({
  baseURL: url,
});
export const apiPath = () => {
  return url;
};
